export default "__VITE_ASSET__g3dSaxzo__"